<style lang="scss" scoped>
.top-title {
    background: white;
    display: flex;
    justify-content: space-between;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding: 5px 0;
    box-shadow: 0 0 8px #ddd;
}
</style>
<template>
	<section style="min-height: 800px">
        <div v-if="alertbox || type === 'query'" class="top-title">
            <Alert show-icon theme="info" style="display: inline-block; margin-bottom: 0">{{$t('fbb.markchange.tip', { defaultValue: '单件换标默认贴产品标，换标后sku数量和换标前一致。拆箱入单件可自行选择是否贴产品标，换标后sku数量可输入供仓库参考。' })}}</Alert>
            <!-- <div class="bottom-button" v-if="alertbox">
                <vButton v-for="item in getStatusBtns" :key="item.name" @click="item.run" :theme="item.theme" class="margin-right-10">{{item.name}}</vButton>
            </div> -->
            <span >
                <vButton v-for="item in getStatusBtns" :key="item.name" @click="item.run" :theme="item.theme" class="margin-right-10">{{item.name}}</vButton>
            </span>
        </div>
        <div v-else>
            <Alert show-icon theme="info">{{$t('fbb.markchange.tip', { defaultValue: '单件换标默认贴产品标，换标后sku数量和换标前一致。拆箱入单件可自行选择是否贴产品标，换标后sku数量可输入供仓库参考。' })}}</Alert>
        </div>
        <div style="display: flex">
            <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" :expand="false" style="width:calc(200%/3);margin-right:10px;" >
                <compFormQuery v-if="isQuery" class="margin-layout" :formdata="getBase" :value="formData" placeholder="--" ></compFormQuery>
                <compFormEdit v-else ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"></compFormEdit>
            </compWrapper>
            <compWrapper :title="$t('global.common.attache',{defaultValue:'附件信息'})" :expand="false" style="width:calc(100%/3);">
                <compAttach class="margin-layout" ref="attachlist" :data="attachList" :isLabel="formData.valueAdded" :status="getStatus" :activeid="id" @on-update="setAttach"></compAttach>
            </compWrapper>
        </div>
		<compWrapper :title="$t('global.common.product_info',{defaultValue:'产品信息'})" :expand="false">
			<compProduct class="margin-layout" ref="productlist" :baseData="formData" :querytype="querytype" :data="productList" @on-update="setProduct"></compProduct>
			<vButtonGroup slot="footer" v-if="!alertbox && type !== 'query'">
				<vButton v-for="item in getStatusBtns" :key="item.name" @click="item.run" :theme="item.theme">{{item.name}}</vButton>
			</vButtonGroup>
		</compWrapper>
		<compWrapper v-if="type==='query'" :title="$t('global.log.name',{defaultValue:'操作历史'})" >
			<vTable class="margin-15" :columns="getLogColumns" :data="logList" border></vTable>
			<!-- <vButtonGroup slot="footer" v-if="alertbox" >
				<vButton v-for="item in getStatusBtns" :key="item.name" @click="item.run" :theme="item.theme">{{item.name}}</vButton>
			</vButtonGroup> -->
		</compWrapper>
        <compModal v-model="modalProps.show" v-bind="modalProps" @on-close="modalProps.show=false" @on-confirm="modalProps.show=false">
			<component v-if="modalProps.component" :is="modalProps.component" v-bind="modalProps.props" @on-close="modalProps.show=false" v-on="modalProps.on"/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { HttpMarkChangeDetail, HttpMarkChangeSave, HttpMarkChangeSubmit, HttpMarkChangeRevokeExamine, HttpMarkChangeExamine, HttpMarkChangeComplete, HttpMarkChangeCancel, HttpMarkSaveAndSubmit, HttpMarkRepushWarehouse } from '@/service/misc';
import { mapGetters } from 'vuex';
import compAttach from './attach';
import compProduct from './product';

import mixin from "../mixin";
import { Checkbox } from 'view-design';

export default {
	mixins: [mixin],
	props: ['activeid', 'querytype', 'alertbox', 'isManage'],
	components: {
		compAttach,
		compProduct,
	},
	data() {
		return {
			loading: false,
			type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
            manage: this.isManage || this.$route.query.isManage,
			formData: {
                valueAdded: [],
			},
			productList: [],
			attachList: [],
			logList: [],
            modalProps: {
				show: false,
				formdata: null,
			},
		};
	},
	async created() {
        this.getDetail();
        // 添加权限
		// this.perUpdate = this.handleAuth('fbb.inboundplan.update');
	},
	computed: {
		...mapGetters('dictionary', ['getCusproductList', 'getUserManageWarehouseList', 'getFilterDisabledWarehouse']),
		getStatus() {
			return this.type !== 'add' && this.formData.status
		},
		isEdit() {
			return this.type === 'edit'
		},
		isQuery() {
			return this.type === 'query'
		},
		isAdd() {
			return this.type === 'add'
		},
		// 根据状态显示不同按钮
		getStatusBtns() {
			const getStatus = this.getStatus;
			const btn = [
                {
                    name: this.$t('global.common.return', { defaultValue: '返回' }),
                    show: !this.alertbox,
                    run: this.cancel
                },
                {
                    name: this.$t('fbb.inbound.save_draft', { defaultValue: '保存为草稿' }),
                    show: !this.manage && (this.isAdd || (this.isEdit && getStatus == 0) || (getStatus == 6 && this.isEdit)),
                    run: this.save
                },
                {
                    name: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                    show: !this.manage && this.isQuery && (getStatus == 0 || getStatus == 5 || getStatus == 6 || getStatus == 10),
                    run: this.cancelOperate
                },
                // 新增、编辑时提交审核
                {
                    name: this.$t('fbb.alloment.save_and_commit', { defaultValue: "保存并提交" }),
                    show: !this.manage && (this.isAdd || this.isEdit),
                    theme: 'primary',
                    run: this.submit
                },
                {
                    name: "推送仓库",
                    show: getStatus == 10 ,
                    run: this.pushWarehouse
                },
                // 查看时提交审核
                {
                    name: this.$t('fbb.inbound.submit_audit', { defaultValue: '提交审核' }),
                    show: !this.manage && (this.isQuery && ( getStatus == 0 || getStatus == 6)) ,
                    theme: 'primary',
                    run: this.submitQuery
                },
                {
                    name: this.$t('fbb.alloment.cancel_audit', { defaultValue: "撤销审核" }),
                    show: !this.manage && getStatus == 5 ,
                    run: this.revocate
                },
                {
                    name: "审核",
                    show: this.manage && getStatus == 5 ,
                    theme: 'primary',
                    run: this.audit
                },
                {
                    name: "完成",
                    show: this.manage && (getStatus == 10 || getStatus == 15),
                    theme: 'primary',
                    run: this.complete
                },
			]
			return btn.filter(item => item.show);
		},
		getBase() {
			return [
                {
                    label: "单据号",
                    key: 'orderNo',
                    show: this.isQuery,
                    render: (h)=>{
                        return <div>
                            <span>{this.formData.changeLabelPlanNo || '--'}</span>
                        </div>
                    },
                },
                {
                    label: "仓库",
                    key: 'orgWarehouseId',
                    tag: 'vSelect',
                    options: this.manage ? this.getUserManageWarehouseList.map(item=>{
                        return {
                            label:item.label,
                            value:item.attach.id
                        }
                    }):this.getFilterDisabledWarehouse.map(item=>{
                        return {
                            value:item.value,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable:true,
                    },
                    on: {
						'on-change': (val) => {
                            this.productList = [];
						},
					}
                },
                {
                    label: "业务类型",
                    key: 'businessType',
                    tag: 'vSelect',
                    options: [
                        { label: "单件换标", value: 0},
                        { label: "拆箱入单件", value: 1},
                    ],
                    props: {
                        clearable:false,
                    },
                    on: {
						'on-change': (val) => {
                            this.formData.valueAdded = [];
                            this.productList = [];
							val === 0 ? this.formData.valueAdded.push(1) : this.formData.valueAdded = [];
						},
					}
                },
                {
                    label: "增值服务",
                    // tag: "vCheckBox",
                    // key: "valueAdded",
                    // options: [
                    //     {
                    //         label: "产品标",
                    //         trueValue: '1'
                    //     },
                    // ],
                    // props: {
                    //     disabled: this.formData.businessType == 0,
                    // },
                    // show: this.formData.businessType !== undefined,
                    // required: false,
                    tag: "div",
                    children: (h) => {
                        return (
                            <CheckboxGroup v-model={this.formData.valueAdded}>
                                <Checkbox label={1} disabled={this.formData.businessType == 0}>产品标</Checkbox>
                            </CheckboxGroup>
                        );
                    },
                    show: this.formData.businessType !== undefined && !this.isQuery,
                },
                {
                    label: "增值服务",
                    key: "valueAdded",
                    render: (h)=>{
                        let valueService = this.formData.valueAdded.split(',');
                        let value = valueService.map(item=>{
                            return item == '1' ? '产品标' : '--'
                        })
                        return value.join('，')
                    },
                    show: this.formData.businessType !== undefined && this.isQuery,
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: "lineId",
                    tag: "vSelect",
                    options: this.getCusproductList.map((item) => {
                        return {
                            value: item.value,
                            label: item.attach.name,
                        }
                    }),
                    required: false,
                    props: {
                        filterable: true,
                        placeholder: "换标前SKU项目，非必填"
                    },
                },
                {
                    label: this.$t('global.common.notes', { defaultValue: '备注' }),
                    tag: "Input",
                    key: "remark",
                    required: false,
                    props: {
                        type: 'textarea',
                        autosize: { minRows: 3, maxRows: 6 },
                        wrap: 'soft'
                    },
                },
			];
		},
		getLogColumns() {
			return [
                {
                    title: this.$t('global.common.operator', { defaultValue: '操作人' }),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
                    key: 'opAction',
                    render: (h, { row }) => {
                        return this.getLogActions[row.operateType] || '';
                    },
                },
                {
                    title: this.$t('global.common.notes', { defaultValue: '备注' }),
                    key: 'remark',
                    width: "30%",
                    render: (h, { row }) => {
                        return <div>
                            {row.remark || '--'}
                        </div>
                    },
                },
                {
                    title: this.$t('global.common.operate_time', { defaultValue: '操作时间' }),
                    key: 'createdAt',
                },
            ];
		},
	},
	methods: {
        getDetail(arr) {
            if( this.isAdd ){
                this.attachList = arr
                return
            }
			this.loading = true;
			HttpMarkChangeDetail({id: this.id,}).then(res => {
                this.formData = res.data;
                this.logList = res.data.orderLogEntities;
                this.attachList = res.data.orderAttachesEntities;
                this.productList = res.data.changeLabelPlanItemEntities;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
        setProduct(arr) {
            if(arr[0]){
                this.$set(this.formData, 'lineId', arr[0].lineId)
            }
            this.productList = arr;
        },
        setAttach(arr){
            this.attachList = arr;
        },
		//保存为草稿
		async save() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
            const attachList = this.attachList ? this.attachList.map( item => {
                return {
                    id: item.id,
                    typeCode: item.attachType,
                    filename: item.filename,
                    url: item.fileurl
                }
            }): [];
            if(this.formData.valueAdded.indexOf(1) >= 0){
                if(attachList.filter(item=>item.typeCode == 'ItemLabel').length === 0){
                    this.$VMessage.error("选择增值服务为产品标时需要上传产品标/ItemLabel！");
                    return
                }
            }
            if(this.productList.length == 0){
                this.$VMessage.error("请添加SKU信息！");
                return
            }
            this.loading = true;
            this.formData.valueAdded = this.formData.valueAdded.toString()
			HttpMarkChangeSave({ id: this.id, orgId: global.SYSID, ...this.formData, changeLabelPlanItemParamList: this.productList, orderAttachParams: attachList})
            .then( res => {
				this.$VMessage.success(res.message);
				this.cancel();
			},err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		// 新增、编辑时提交审核
		async submit() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
            const attachList = this.attachList ? this.attachList.map( item => {
                return {
                    id: item.id,
                    typeCode: item.attachType,
                    filename: item.filename,
                    url: item.fileurl
                }
            }): [];
            if(this.formData.valueAdded.indexOf(1) >= 0){
                if(attachList.filter(item=>item.typeCode == 'ItemLabel').length === 0){
                    this.$VMessage.error("选择增值服务为产品标时需要上传产品标/ItemLabel！");
                    return
                }
            }
            if(this.productList.length == 0){
                this.$VMessage.error("请添加SKU信息！");
                return
            }
            this.formData.valueAdded = this.formData.valueAdded.toString()
            this.loading = true;
            HttpMarkSaveAndSubmit({ id: this.id, orgId: global.SYSID, ...this.formData, changeLabelPlanItemParamList: this.productList, orderAttachParams: attachList})
            .then( res => {
				this.$VMessage.success(res.message);
				this.cancel();
			},err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
        // 查看时提交审核
        async submitQuery() {
            this.modalProps = {
                show: true,
                alert: "error",
                title: this.$t('', { defaultValue: "提交审核" }),
                width: 460,
                params: { id: this.id },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t('global.common.notes', { defaultValue: "备注" }),
                        required: false,
                    }
                ],
                ajaxRequest: HttpMarkChangeSubmit,
                callback:()=>{
                    if (this.alertbox){
                        this.$VMessage.success('操作成功！');
                        this.$emit("on-update");
                    }
                    else{
                        this.$router.push({name: 'markChangeCustom'})
                        this.$VMessage.success('操作成功！');
                    }
                }
            };
        },
        async revocate() {
            this.modalProps = {
                show: true,
                alert: "error",
                title: this.$t('', { defaultValue: "撤销审核" }),
                width: 460,
                params: { id: this.id },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t('global.common.notes', { defaultValue: "备注" }),
                        required: false,
                    }
                ],
                ajaxRequest: HttpMarkChangeRevokeExamine,
                callback:()=>{
                    if (this.alertbox){
                        this.$VMessage.success('操作成功！');
                        this.$emit("on-update");
                    }
                    else{
                        this.$router.push({name: 'markChangeCustom'})
                        this.$VMessage.success('操作成功！');
                    }
                }
            };
        },
        async audit(){
            this.modalProps = {
                show: true,
                alert: "primary",
                title: "审核",
                width: 460,
                showDesc: false,
                params: { id: this.id },
                formdata: [
                    {
                        label: '',
                        tag: "vRadio",
                        key: "approveFlag",
                        span: 24,
                        options: [
                            {
                                trueValue: 10,
                                label: "审核通过"
                            },
                            {
                                trueValue: 6,
                                label: "审核拒回"
                            },
                        ],
                    },
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t('global.common.notes', { defaultValue: "备注" }),
                        required: false,
                    }
                ],
                ajaxRequest: HttpMarkChangeExamine,
                interceptRequest(params){
                    if(!params.approveFlag) {
                        this.$VMessage.error('请填写必填项！')
                        return false
                    }
                    return params
                },
                callback:()=>{
                    if (this.alertbox){
                        this.$VMessage.success('操作成功！');
                        this.$emit("on-update");
                    }
                    else{
                        this.$router.push({name: 'markChangeManage'})
                        this.$VMessage.success('操作成功！');
                    }
                }
            };
        },
        async cancelOperate() {
            this.modalProps = {
                show: true,
                alert: "error",
                title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                width: 460,
                params: { id: this.id },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t('global.common.notes', { defaultValue: "备注" }),
                        required: false
                    }
                ],
                ajaxRequest: HttpMarkChangeCancel,
                callback:()=>{
                    if (this.alertbox){
                        this.$VMessage.success('操作成功！');
                        this.$emit("on-update");
                    }
                    else{
                        this.$router.push({name: 'markChangeCustom'})
                        this.$VMessage.success('操作成功！');
                    }
                }
            };
        },
        async pushWarehouse(){
            this.modalProps = {
                show: true,
                alert: "primary",
                title: "推送仓库",
                width: 460,
                params: { id: this.id },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t('global.common.notes', { defaultValue: "备注" }),
                        required: false
                    }
                ],
                ajaxRequest: HttpMarkRepushWarehouse,
                callback:()=>{
                    if (this.alertbox){
                        this.$VMessage.success('操作成功！');
                        this.$emit("on-update");
                    }
                    else{
                        this.$router.push({ name: this.manage ? 'markChangeManage' : 'markChangeCustom'})
                        this.$VMessage.success('操作成功！');
                    }
                }
            };
        },
        async complete() {
            this.modalProps = {
                show: true,
                alert: "info",
                title: this.$t('', { defaultValue: '完成' }),
                width: 460,
                params: { id: this.id },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t('global.common.notes', { defaultValue: "备注" }),
                        required: false,
                    }
                ],
                ajaxRequest: HttpMarkChangeComplete,
                callback:()=>{
                    if (this.alertbox){
                        this.$VMessage.success('操作成功！');
                        this.$emit("on-update");
                    }
                    else{
                        this.$router.push({name: 'markChangeManage'})
                        this.$VMessage.success('操作成功！');
                    }
                }
            };
        },
		cancel() {
			if (this.alertbox) {
				this.$emit('on-close')
			} else {
				this.$router.push({ name: this.manage ? 'markChangeManage' : 'markChangeCustom'})
			}
		},
	}
};
</script>
